import Loadable from 'react-loadable';

export const CompositePurchaseDoc = Loadable({
  loader: () => import('./CompositePurchaseDoc'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/CompositePurchaseDoc/index.tsx